import React from "react"

export type IconProps = React.SVGProps<SVGSVGElement> & {
  size?: "small" | "big" | "huge"
}

export const IconLocation: React.FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    width="24"
    height="24"
    {...props}
  >
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
  </svg>
)

export const IconKey: React.FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    width="24"
    height="24"
    {...props}
  >
    <path d="M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
  </svg>
)

export const IconDocs: React.FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    width="24"
    height="24"
    {...props}
  >
    <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" />
  </svg>
)

export const IconFilter: React.FC<IconProps> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11 20C10.7167 20 10.4792 19.9042 10.2875 19.7125C10.0958 19.5208 10 19.2833 10 19V13L4.2 5.6C3.95 5.26667 3.9125 4.91667 4.0875 4.55C4.2625 4.18333 4.56667 4 5 4H19C19.4333 4 19.7375 4.18333 19.9125 4.55C20.0875 4.91667 20.05 5.26667 19.8 5.6L14 13V19C14 19.2833 13.9042 19.5208 13.7125 19.7125C13.5208 19.9042 13.2833 20 13 20H11ZM12 12.3L16.95 6H7.05L12 12.3Z"
      fill="currentColor"
    />
  </svg>
)

export const IconDownloadFile: React.FC<IconProps> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 20C5.45 20 4.97917 19.8042 4.5875 19.4125C4.19583 19.0208 4 18.55 4 18V15H6V18H18V15H20V18C20 18.55 19.8042 19.0208 19.4125 19.4125C19.0208 19.8042 18.55 20 18 20H6ZM12 16L7 11L8.4 9.55L11 12.15V4H13V12.15L15.6 9.55L17 11L12 16Z"
      fill="currentColor"
    />
  </svg>
)

export const IconArrowBack: React.FC<IconProps> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 20L4 12L12 4L13.425 5.4L7.825 11H20V13H7.825L13.425 18.6L12 20Z"
      fill="currentColor"
    />
  </svg>
)

export const IconStates: React.FC<IconProps> = ({ size = "big", ...props }) => {
  switch (size) {
    case "huge":
      return (
        <svg
          width="76"
          height="87"
          viewBox="0 0 76 87"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M75 44.3521L75 66.0282L38.3008 86.5L19.6504 76.2641M75 44.3521L75 22.6761L56.6504 11.838L38.3008 1L1 22.6761L0.999999 66.0282L19.6504 76.2641M75 44.3521L19.6504 76.2641"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M19.6506 12.0647L75 43.75"
            stroke="currentColor"
            strokeLinecap="round"
          />
          <path
            d="M1.06696 22.6265L74.8995 65.8794"
            stroke="currentColor"
            strokeLinecap="round"
          />
          <path
            d="M1 43.75L56.8181 75.9382"
            stroke="currentColor"
            strokeLinecap="round"
          />
          <path
            d="M1.06696 65.8794L74.8995 22.6265"
            stroke="currentColor"
            strokeLinecap="round"
          />
          <path
            d="M1 43.75L56.5 12.4"
            stroke="currentColor"
            strokeLinecap="round"
          />
          <path
            d="M38.2343 1.00002V86.5M19.5 12.4V75.9533M56.5 12.4V75.9533"
            stroke="currentColor"
            strokeLinecap="round"
          />
        </svg>
      )
    case "big":
      return (
        <svg
          width="28"
          height="32"
          viewBox="0 0 28 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M27 16.2113L27 23.8169L14.1057 31L7.55285 27.4085M27 16.2113L27 8.60563L20.5528 4.80282L14.1057 1L1 8.60563L1 23.8169L7.55285 27.4085M27 16.2113L7.55285 27.4085"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path d="M8 5L27 16" stroke="currentColor" strokeLinecap="round" />
          <path
            d="M1.5 9L26.5 23.5"
            stroke="currentColor"
            strokeLinecap="round"
          />
          <path d="M1 16L20.5 27" stroke="currentColor" strokeLinecap="round" />
          <path
            d="M1.5 23.5L26.5 9"
            stroke="currentColor"
            strokeLinecap="round"
          />
          <path d="M1 16L20.5 5" stroke="currentColor" strokeLinecap="round" />
          <path
            d="M14.1 1.50021L14.2 30.4999M7.5 5V27.2994M20.5 5V26.5"
            stroke="currentColor"
            strokeLinecap="round"
          />
        </svg>
      )
    case "small":
      return (
        <svg
          width="16"
          height="18"
          viewBox="0 0 16 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M15 9.19068L15 13.286L8.05691 17.1538L4.52846 15.2199M15 9.19068L15 5.09534L11.5285 3.04767L8.05691 1L1 5.09534L1 13.286L4.52846 15.2199M15 9.19068L4.52846 15.2199"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
          <path
            d="M4.76923 3.15385L15 9.07692"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinecap="round"
          />
          <path
            d="M1.26923 5.30769L14.7308 13.1154"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinecap="round"
          />
          <path
            d="M1 9.07692L11.5 15"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinecap="round"
          />
          <path
            d="M1.26923 13.1154L14.7308 5.30769"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinecap="round"
          />
          <path
            d="M1 9.07692L11.5 3.15385"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinecap="round"
          />
          <path
            d="M8.05385 1.26935L8.10769 16.8845M4.5 3.15385V15.1612M11.5 3.15385V14.7308"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinecap="round"
          />
        </svg>
      )
    default:
      break
  }
}

export const IconMetropolitans: React.FC<IconProps> = ({
  size = "big",
  ...props
}) => {
  switch (size) {
    case "huge":
      return (
        <svg
          width="76"
          height="87"
          viewBox="0 0 76 87"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M1 66.0282V22.6761L38.3008 1L56.6504 11.838L75 22.6761V66.0282L38.3008 86.5L1 66.0282Z"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M1 66.0282V22.6761L38.3008 1L56.6504 11.838L75 22.6761V66.0282L38.3008 86.5L1 66.0282Z"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M8 69.9029L8 26.9439L38.4231 10.0529L53.1509 18.4984L68 26.8248V69.9029"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M16 73.9265V30.8177L38.8174 18.1L49.8632 24.4589L61 30.7281V73.9265"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M23 78.453V35.703L38.818 27.153L54 35.703V77.95"
            stroke="currentColor"
            strokeLinejoin="round"
          />
        </svg>
      )
    case "big":
      return (
        <svg
          width="28"
          height="32"
          viewBox="0 0 28 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M1 23.8169V8.60563L14.1057 1L20.5528 4.80282L27 8.60563V23.8169L14.1057 31L1 23.8169Z"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M1 23.8169V8.60563L14.1057 1L20.5528 4.80282L27 8.60563V23.8169L14.1057 31L1 23.8169Z"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M3.5 25V9.97686L14.1481 4L19.3028 6.98843L24.5 9.93472V25"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M6 26.5V11.4826L14.1128 7L18.0402 9.24132L22 11.451V26.5"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M8.5 28V13L14.1128 10L19.5 13V28"
            stroke="currentColor"
            strokeLinejoin="round"
          />
        </svg>
      )
    case "small":
      return (
        <svg
          width="16"
          height="18"
          viewBox="0 0 16 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M1 13.286V5.09534L8.05691 1L11.5285 3.04767L15 5.09534V13.286L8.05691 17.1538L1 13.286Z"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
          <path
            d="M1 13.286V5.09534L8.05691 1L11.5285 3.04767L15 5.09534V13.286L8.05691 17.1538L1 13.286Z"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
          <path
            d="M2.34616 13.9231V5.8337L8.07975 2.61539L10.8554 4.22454L13.6539 5.81101V13.9231"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
          <path
            d="M3.69232 14.7308V6.6445L8.06077 4.23077L10.1755 5.43763L12.3077 6.62748V14.7308"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
          <path
            d="M5.03845 15.5385V7.46154L8.06075 5.84615L10.9615 7.46154V15.5385"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
        </svg>
      )
    default:
      break
  }
}

export const IconCounties: React.FC<IconProps> = ({
  size = "big",
  ...props
}) => {
  switch (size) {
    case "huge":
      return (
        <svg
          width="76"
          height="87"
          viewBox="0 0 76 87"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M1 66.0282V22.6761L38.3008 1L56.6504 11.838L75 22.6761V66.0282L38.3008 86.5L1 66.0282Z"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M38.2853 1.50659V86.1103"
            stroke="currentColor"
            strokeLinecap="round"
          />
          <path
            d="M38.4385 44.0618L74.8651 22.7842"
            stroke="currentColor"
            strokeLinecap="round"
          />
          <path d="M38.4385 22.7842L56.4997 33.7745" stroke="currentColor" />
          <path d="M38.4385 11.1322L65.7584 28.3569" stroke="currentColor" />
          <path d="M38.4385 33.9296L46.7062 39.2232" stroke="currentColor" />
        </svg>
      )
    case "big":
      return (
        <svg
          width="29"
          height="32"
          viewBox="0 0 29 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M1 23.8169V8.60563L14.6098 1L21.3049 4.80282L28 8.60563V23.8169L14.6098 31L1 23.8169Z"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M14.5 1.26379V30.6824"
            stroke="currentColor"
            strokeLinecap="round"
          />
          <path
            d="M14.5 16.5L27.5 9"
            stroke="currentColor"
            strokeLinecap="round"
          />
          <path
            d="M15 12.5L17.5 14M15 5L24.5 10.5M15 9L21 12.5"
            stroke="currentColor"
            strokeLinecap="square"
          />
        </svg>
      )
    case "small":
      return (
        <svg
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M1 12.831V4.94366L8.05691 1L11.5285 2.97183L15 4.94366V12.831L8.05691 16.5556L1 12.831Z"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
          <path
            d="M8 1.13678V16.3909"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinecap="round"
          />
          <path
            d="M8 9.03704L14.7407 5.14815"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinecap="round"
          />
          <path
            d="M8.25925 6.96296L9.55554 7.74074M8.25925 3.07407L13.1852 5.92593M8.25925 5.14815L11.3704 6.96296"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinecap="square"
          />
        </svg>
      )
    default:
      break
  }
}

export const IconZips: React.FC<IconProps> = ({ size = "big", ...props }) => {
  switch (size) {
    case "huge":
      return (
        <svg
          width="76"
          height="87"
          viewBox="0 0 76 87"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M1 66.0282V22.6761L38 1L56.6504 11.838L75 22.6761V66.0282L38 86.5L1 66.0282Z"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M1.5 23.1294L38 43.2471L74 23.1294"
            stroke="currentColor"
            strokeLinecap="square"
          />
          <path
            d="M1 23.1294H38V1"
            stroke="currentColor"
            strokeLinecap="round"
          />
          <path
            d="M1 33.1882L38 54.3118L75 33.1882"
            stroke="currentColor"
            strokeLinecap="round"
          />
          <path
            d="M1 55.3177L38 76.4412L75 55.3177"
            stroke="currentColor"
            strokeLinecap="round"
          />
          <path
            d="M38 43.2471V86.5"
            stroke="currentColor"
            strokeLinecap="round"
          />
          <path
            d="M1 44.7559L38 65.3765L75 44.2529"
            stroke="currentColor"
            strokeLinecap="round"
          />
        </svg>
      )
    case "big":
      return (
        <svg
          width="28"
          height="32"
          viewBox="0 0 28 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M1 23.8169V8.60563L14.1057 1L20.5528 4.80282L27 8.60563V23.8169L14.1057 31L1 23.8169Z"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M1 23.8169V8.60563L14.1057 1L20.5528 4.80282L27 8.60563V23.8169L14.1057 31L1 23.8169Z"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M1.5 9L14.1074 15L26.5 9"
            stroke="currentColor"
            strokeLinecap="round"
          />
          <path
            d="M1.5 8.5L14 8V1.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1 12.5L14 19L27 12.5"
            stroke="currentColor"
            strokeLinecap="round"
          />
          <path
            d="M1 20L14 27L27 20"
            stroke="currentColor"
            strokeLinecap="round"
          />
          <path d="M14 15V30.5" stroke="currentColor" strokeLinecap="round" />
          <path
            d="M1.22361 16.0528C0.976616 15.9293 0.67628 16.0294 0.552786 16.2764C0.429292 16.5234 0.529405 16.8237 0.776394 16.9472L1.22361 16.0528ZM14.0001 23L13.7765 23.4472L14.0045 23.5612L14.2308 23.4436L14.0001 23ZM26.7307 16.9436L27.1743 16.7129L26.7129 15.8257L26.2693 16.0564L26.7307 16.9436ZM0.776394 16.9472L13.7765 23.4472L14.2237 22.5528L1.22361 16.0528L0.776394 16.9472ZM14.2308 23.4436L26.7307 16.9436L26.2693 16.0564L13.7694 22.5564L14.2308 23.4436Z"
            fill="currentColor"
          />
        </svg>
      )
    case "small":
      return (
        <svg
          width="16"
          height="18"
          viewBox="0 0 16 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M1 13.286V5.09534L8.05691 1L11.5285 3.04767L15 5.09534V13.286L8.05691 17.1538L1 13.286Z"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
          <path
            d="M1 13.286V5.09534L8.05691 1L11.5285 3.04767L15 5.09534V13.286L8.05691 17.1538L1 13.286Z"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
          <path
            d="M1.26923 5.30769L8.05785 8.53846L14.7308 5.30769"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinecap="round"
          />
          <path
            d="M1.26923 5.03846L7.99999 4.76923V1.26923"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1 7.19231L8 10.6923L15 7.19231"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinecap="round"
          />
          <path
            d="M1 11.2308L8 15L15 11.2308"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinecap="round"
          />
          <path
            d="M8 8.53846V16.8846"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinecap="round"
          />
          <path
            d="M1.13416 9.07782C0.98597 9.00373 0.805768 9.0638 0.731671 9.21199C0.657575 9.36018 0.717643 9.54039 0.865837 9.61448L1.13416 9.07782ZM8.00004 12.8462L7.86588 13.1145L8.00272 13.1829L8.13845 13.1123L8.00004 12.8462ZM14.8692 9.61232L15.1353 9.47391L14.8585 8.94158L14.5924 9.07999L14.8692 9.61232ZM0.865837 9.61448L7.86588 13.1145L8.13421 12.5778L1.13416 9.07782L0.865837 9.61448ZM8.13845 13.1123L14.8692 9.61232L14.5924 9.07999L7.86164 12.58L8.13845 13.1123Z"
            fill="currentColor"
          />
        </svg>
      )
    default:
      break
  }
}

export const IconVenues: React.FC<IconProps> = ({ size = "big", ...props }) => {
  switch (size) {
    case "huge":
      return (
        <svg
          width="74"
          height="86"
          viewBox="0 0 74 86"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M37.0597 0.0640733C37.2075 -0.0219614 37.39 -0.0213123 37.5372 0.0657715L73.7671 21.501C73.9114 21.5864 74 21.742 74 21.9102V64.7806C74 64.953 73.907 65.1119 73.757 65.1957L37.5271 85.44C37.385 85.5194 37.2123 85.52 37.0697 85.4416L0.245883 65.1973C0.0942694 65.1139 0 64.9542 0 64.7806V21.9102C0 21.7408 0.0898485 21.5842 0.235809 21.4993L37.0597 0.0640733ZM0.946233 22.1839V64.4992L37.2951 84.4824L73.0538 64.5014V22.1816L37.295 1.02519L0.946233 22.1839Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M37.2121 10.961C37.3479 10.8846 37.5112 10.8858 37.6459 10.9641L51.0273 18.7428L51.031 18.745L64.5226 26.414C64.6694 26.4974 64.7608 26.6588 64.7608 26.8343V59.0634C64.7608 59.2411 64.667 59.4041 64.5174 59.4865L37.6369 74.2935C37.5071 74.365 37.3524 74.3662 37.2216 74.2967L9.57198 59.5994C9.41909 59.5182 9.32269 59.3533 9.32269 59.1731V26.944C9.32269 26.7678 9.41488 26.6059 9.56256 26.5228L37.2121 10.961ZM10.2308 27.2302V58.8793L37.4226 73.3332L63.8527 58.7743V27.1191L50.5956 19.5833L50.5918 19.5812L37.4228 11.9259L10.2308 27.2302Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M37.0224 21.455C37.1701 21.37 37.352 21.3713 37.4986 21.4584L46.4606 26.7835L46.4645 26.7858L55.5004 32.0358C55.6466 32.1207 55.7365 32.2773 55.7365 32.4469V54.5135C55.7365 54.6853 55.6441 54.8437 55.4949 54.9278L37.489 65.0658C37.3475 65.1455 37.1751 65.1468 37.0324 65.0692L18.5114 55.0063C18.3586 54.9233 18.2634 54.763 18.2634 54.5886V32.522C18.2634 32.3517 18.3542 32.1945 18.5013 32.1099L37.0224 21.455ZM19.2097 32.7973V54.3055L37.2535 64.1092L54.7903 54.2353V32.7208L45.9826 27.6034L37.2537 22.4168L19.2097 32.7973Z"
            fill="currentColor"
          />
          <path
            d="M47.0184 43.1304C47.0184 48.6035 42.5878 53.0391 37.1238 53.0391C31.6597 53.0391 27.2291 48.6035 27.2291 43.1304C27.2291 37.6574 31.6597 33.2217 37.1238 33.2217C42.5878 33.2217 47.0184 37.6574 47.0184 43.1304Z"
            stroke="currentColor"
          />
        </svg>
      )
    case "big":
      return (
        <svg
          width="28"
          height="32"
          viewBox="0 0 28 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M1 23.8169V8.60563L14.1057 1L20.5528 4.80282L27 8.60563V23.8169L14.1057 31L1 23.8169Z"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M1 23.8169V8.60563L14.1057 1L20.5528 4.80282L27 8.60563V23.8169L14.1057 31L1 23.8169Z"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M4 22.0904V10.2278L14.141 4.5L19.0503 7.36391L24 10.1874V22.05L14.141 27.5L4 22.0904Z"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M7.5 19.972V12.2355L14.0917 8.5L17.2827 10.3678L20.5 12.2092V19.9457L14.0917 23.5L7.5 19.972Z"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M17.5 16C17.5 17.933 15.933 19.5 14 19.5C12.067 19.5 10.5 17.933 10.5 16C10.5 14.067 12.067 12.5 14 12.5C15.933 12.5 17.5 14.067 17.5 16Z"
            stroke="currentColor"
          />
        </svg>
      )
    case "small":
      return (
        <svg
          width="16"
          height="18"
          viewBox="0 0 16 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M1 13.286V5.09534L8.05691 1L11.5285 3.04767L15 5.09534V13.286L8.05691 17.1538L1 13.286Z"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
          <path
            d="M1 13.286V5.09534L8.05691 1L11.5285 3.04767L15 5.09534V13.286L8.05691 17.1538L1 13.286Z"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
          <path
            d="M2.61539 12.3564V5.96883L8.07595 2.88461L10.7194 4.42672L13.3846 5.94708V12.3346L8.07595 15.2692L2.61539 12.3564Z"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
          <path
            d="M4.5 11.2157V7.0499L8.04937 5.03846L9.76761 6.04418L11.5 7.03572V11.2015L8.04937 13.1154L4.5 11.2157Z"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
          <path
            d="M9.85385 9.07693C9.85385 10.1008 9.02385 10.9308 8 10.9308C6.97615 10.9308 6.14615 10.1008 6.14615 9.07693C6.14615 8.05308 6.97615 7.22308 8 7.22308C9.02385 7.22308 9.85385 8.05308 9.85385 9.07693Z"
            stroke="currentColor"
            strokeWidth="0.6"
          />
        </svg>
      )
    default:
      break
  }
}

export const IconNeighbourhoods: React.FC<IconProps> = ({
  size = "big",
  ...props
}) => {
  switch (size) {
    case "huge":
      return (
        <svg
          width="75"
          height="87"
          viewBox="0 0 75 87"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <rect
            x="8"
            y="45.7588"
            width="11"
            height="13.0824"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M19 52.3L8.5 52.3"
            stroke="currentColor"
            strokeLinecap="round"
          />
          <path
            d="M19 52.3L8.5 52.3"
            stroke="currentColor"
            strokeLinecap="round"
          />
          <rect
            x="8"
            y="32.6823"
            width="11"
            height="13.0824"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M19 39.2235L8.5 39.2235"
            stroke="currentColor"
            strokeLinecap="round"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M33.3 53.1846H42.6078V58.7936H33.3V53.1846ZM33.3 59.7936V65.4026H42.6078V59.7936H33.3ZM32.3 52.1846H33.3H42.6078H43.6078V53.1846V65.4026V66.4026H42.6078H33.3H32.3V65.4026V53.1846V52.1846Z"
            fill="currentColor"
          />
          <path
            d="M1 66.0282V22.6761L37.7967 1L55.8984 11.838L74 22.6761V66.0282L37.7967 86.5L1 66.0282Z"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M26 28.1588V9.04706"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M50 73.4235V36.2059"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M26 73.4235V48.2327L38 41.2353L50 48.2327V73.4235"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M26 79.9618V36.2059L38 29.1647L50 36.2059V79.4588"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M57.5 46.2588H66.8078V51.8H57.5V46.2588ZM57.5 52.8V58.3412H66.8078V52.8H57.5ZM56.5 45.2588H57.5H66.8078H67.8078V46.2588V58.3412V59.3412H66.8078H57.5H56.5V58.3412V46.2588V45.2588Z"
            fill="currentColor"
          />
          <path
            d="M26 31.1765V9.04706"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M26 28.1588V9.04706"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M26 44.2529L26 8.04118"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M26 22.1235L50 8.04118"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M49.5 36.2059L74 22.6265"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M38 29.1647L62 15.0824"
            stroke="currentColor"
            strokeLinejoin="round"
          />
        </svg>
      )
    case "big":
      return (
        <svg
          width="28"
          height="32"
          viewBox="0 0 28 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M1 23.8169V8.60563L14.1057 1L20.5528 4.80282L27 8.60563V23.8169L14.1057 31L1 23.8169Z"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M9.69995 10.5V3.5"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M18.3 26.5V13.5"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M9.70009 27.5V18.5L14.0001 16L18.3 18.5V27.5"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M9.70009 28.5V13.5L14.0001 11L18.3 13.5V28.5"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.1 17H24.1V19H21.1V17ZM21.1 20V22H24.1V20H21.1ZM20.1 16H21.1H24.1H25.1V17V22V23H24.1H21.1H20.1V22V17V16Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.5 21H15.5001V23H12.5V21ZM12.5 24V26H15.5001V24H12.5ZM11.5 20H12.5H15.5001H16.5001V21V26V27H15.5001H12.5H11.5V26V21V20Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.90002 17H6.90009V19H3.90002V17ZM3.90002 20V22H6.90009V20H3.90002ZM2.90002 16H3.90002H6.90009H7.90009V17V22V23H6.90009H3.90002H2.90002V22V17V16Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.90002 11H6.90009V13H3.90002V11ZM3.90002 14V16H6.90009V14H3.90002ZM2.90002 10H3.90002H6.90009H7.90009V11V16V17H6.90009H3.90002H2.90002V16V11V10Z"
            fill="currentColor"
          />
          <path
            d="M9.69995 11.5V3.5"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M9.69995 10.5V3.5"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M9.69995 16V3.5"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M9.5 9L18.5 3.5"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M18.5 13.5L27 8.5"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M14 11L22.5 6"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M9.69995 10.5V3.5"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M18.3 26.5V13.5"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M9.70009 27.5V18.5L14.0001 16L18.3 18.5V27.5"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M9.70009 28.5V13.5L14.0001 11L18.3 13.5V28.5"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M9.69995 11.5V3.5"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M9.69995 10.5V3.5"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M9.69995 16V3.5"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M9.5 9L18.5 3.5"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M18.5 13.5L27 8.5"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M14 11L22.5 6"
            stroke="currentColor"
            strokeLinejoin="round"
          />
        </svg>
      )
    case "small":
      return (
        <svg
          width="16"
          height="18"
          viewBox="0 0 16 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M1 13.286V5.09534L8.05691 1L11.5285 3.04767L15 5.09534V13.286L8.05691 17.1538L1 13.286Z"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
          <path
            d="M5.68459 6.11538V2.34615"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
          <path
            d="M10.3154 14.7308V7.73077"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
          <path
            d="M5.68466 15.2692V10.4231L8.00003 9.07692L10.3154 10.4231V15.2692"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
          <path
            d="M5.68466 15.8077V7.73077L8.00003 6.38461L10.3154 7.73077V15.8077"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.8846 9.67692H13.3769V10.6615L11.8846 10.6615V9.67692ZM11.8846 11.2615V12.2462H13.3769V11.2615H11.8846ZM11.2846 9.07692H11.8846H13.3769H13.9769V9.67692V12.2462V12.8462H13.3769H11.8846H11.2846V12.2462V9.67692V9.07692Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.25385 11.8308H8.74619V12.8154L7.25385 12.8154V11.8308ZM7.25385 13.4154V14.4H8.74619V13.4154H7.25385ZM6.65385 11.2308H7.25385H8.74619H9.34619V11.8308V14.4V15H8.74619H7.25385H6.65385V14.4V11.8308V11.2308Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.62309 9.67692H4.11543V10.6615L2.62309 10.6615V9.67692ZM2.62309 11.2615V12.2462H4.11543V11.2615H2.62309ZM2.02309 9.07692H2.62309H4.11543H4.71543V9.67692V12.2462V12.8462H4.11543H2.62309H2.02309V12.2462V9.67692V9.07692Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.62309 6.44615H4.11543V7.43077H2.62309V6.44615ZM2.62309 8.03077V9.01538H4.11543V8.03077H2.62309ZM2.02309 5.84615H2.62309H4.11543H4.71543V6.44615V9.01538V9.61538H4.11543H2.62309H2.02309V9.01538V6.44615V5.84615Z"
            fill="currentColor"
          />
          <path
            d="M5.68459 6.65385V2.34615"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
          <path
            d="M5.68459 6.11538V2.34615"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
          <path
            d="M5.68459 9.07692V2.34615"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
          <path
            d="M5.57692 5.30769L10.4231 2.34615"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
          <path
            d="M10.4231 7.73077L15 5.03846"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
          <path
            d="M8 6.38461L12.5769 3.69231"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
          <path
            d="M5.68459 6.11538V2.34615"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
          <path
            d="M10.3154 14.7308V7.73077"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
          <path
            d="M5.68466 15.2692V10.4231L8.00003 9.07692L10.3154 10.4231V15.2692"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
          <path
            d="M5.68466 15.8077V7.73077L8.00003 6.38461L10.3154 7.73077V15.8077"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
          <path
            d="M5.68459 6.65385V2.34615"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
          <path
            d="M5.68459 6.11538V2.34615"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
          <path
            d="M5.68459 9.07692V2.34615"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
          <path
            d="M5.57692 5.30769L10.4231 2.34615"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
          <path
            d="M10.4231 7.73077L15 5.03846"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
          <path
            d="M8 6.38461L12.5769 3.69231"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
        </svg>
      )
    default:
      break
  }
}

export const IconBYO: React.FC<IconProps> = ({ size = "big", ...props }) => {
  switch (size) {
    case "huge":
      return (
        <svg
          width="75"
          height="87"
          viewBox="0 0 75 87"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M1 66.0282V22.6761L37.7967 1L55.8984 11.838L74 22.6761V66.0282L37.7967 86.5L1 66.0282Z"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M25.2407 21.2426L50.1246 20.9964L56.0909 31.9076L62.0572 42.8189L49.4051 65.0631L25.172 64.8669L12.9999 45.1552"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <ellipse
            cx="50.1353"
            cy="21.8042"
            rx="4.21154"
            ry="4.275"
            fill="currentColor"
          />
          <ellipse
            cx="50.1353"
            cy="64.5544"
            rx="4.21154"
            ry="4.275"
            fill="currentColor"
          />
          <ellipse
            cx="24.866"
            cy="64.5544"
            rx="4.21154"
            ry="4.275"
            fill="currentColor"
          />
          <path
            d="M15.9413 41.754C15.9413 43.8459 14.2726 45.529 12.2298 45.529C10.187 45.529 8.51825 43.8459 8.51825 41.754C8.51825 39.662 10.187 37.979 12.2298 37.979C14.2726 37.979 15.9413 39.662 15.9413 41.754Z"
            stroke="currentColor"
          />
          <ellipse
            cx="24.866"
            cy="21.8042"
            rx="4.21154"
            ry="4.275"
            fill="currentColor"
          />
          <ellipse
            cx="61.366"
            cy="41.754"
            rx="4.21154"
            ry="4.275"
            fill="currentColor"
          />
        </svg>
      )
    case "big":
      return (
        <svg
          width="28"
          height="32"
          viewBox="0 0 28 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M1 23.8169V8.60563L14.1057 1L20.5528 4.80282L27 8.60563V23.8169L14.1057 31L1 23.8169Z"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            d="M9.63414 8.10269L18.4969 8.01628L20.6219 11.8448L22.7468 15.6733L18.2406 23.4783L9.60965 23.4094L5.18025 16.4101"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <circle cx="18.5005" cy="8.2998" r="1.5" fill="currentColor" />
          <circle cx="18.5005" cy="23.2998" r="1.5" fill="currentColor" />
          <circle cx="9.50053" cy="23.2998" r="1.5" fill="currentColor" />
          <circle cx="5" cy="15.2998" r="1" stroke="currentColor" />
          <circle cx="9.50053" cy="8.2998" r="1.5" fill="currentColor" />
          <circle cx="22.5005" cy="15.2998" r="1.5" fill="currentColor" />
        </svg>
      )
    case "small":
      return (
        <svg
          width="16"
          height="18"
          viewBox="0 0 16 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M1 13.286V5.09534L8.05691 1L11.5285 3.04767L15 5.09534V13.286L8.05691 17.1538L1 13.286Z"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
          <path
            d="M5.64918 4.82452L10.4214 4.778L11.5656 6.8395L12.7099 8.90101L10.2834 13.1037L5.63599 13.0666L3.25093 9.29776"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
          <ellipse
            cx="10.4234"
            cy="4.93066"
            rx="0.807692"
            ry="0.807692"
            fill="currentColor"
          />
          <ellipse
            cx="10.4234"
            cy="13.0076"
            rx="0.807692"
            ry="0.807692"
            fill="currentColor"
          />
          <ellipse
            cx="5.57723"
            cy="13.0076"
            rx="0.807692"
            ry="0.807692"
            fill="currentColor"
          />
          <path
            d="M3.66155 8.6999C3.66155 8.98029 3.43425 9.20759 3.15386 9.20759C2.87347 9.20759 2.64617 8.98029 2.64617 8.6999C2.64617 8.41951 2.87347 8.1922 3.15386 8.1922C3.43425 8.1922 3.66155 8.41951 3.66155 8.6999Z"
            stroke="currentColor"
            strokeWidth="0.6"
          />
          <ellipse
            cx="5.57723"
            cy="4.93066"
            rx="0.807692"
            ry="0.807692"
            fill="currentColor"
          />
          <ellipse
            cx="12.5772"
            cy="8.6999"
            rx="0.807692"
            ry="0.807692"
            fill="currentColor"
          />
        </svg>
      )
    default:
      break
  }
}

export const IconBYOmap: React.FC<IconProps> = (props) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.5 7.5L3.14191 4.5655C3.07564 4.53491 3 4.58331 3 4.65629V22.9398C3 22.9768 3.02047 23.0108 3.05321 23.0282L11.4532 27.4752C11.4825 27.4907 11.5175 27.4907 11.5468 27.4752L19.9565 23.023C19.9839 23.0085 20.0165 23.0075 20.0448 23.0204L28.3586 26.8038C28.4248 26.8339 28.5 26.7855 28.5 26.7128V9.05352C28.5 9.02008 28.4833 8.98886 28.4555 8.97031L25.5 7"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path d="M11.5 27.5V14.5" stroke="currentColor" strokeLinecap="round" />
    <path d="M20 23V18.5" stroke="currentColor" strokeLinecap="round" />
  </svg>
)

export const IconExplore: React.FC<IconProps> = (props) => (
  <svg
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M20 27.7005V18.7005" stroke="currentColor" />
    <path d="M4 27.7005V23.7005" stroke="currentColor" />
    <path d="M12 27.7005V14.7005" stroke="currentColor" />
    <path d="M28 27.7005V10.7005" stroke="currentColor" />
    <path
      d="M4 18.8333L12 9.70052L20 14.2005L27 6.70052"
      stroke="currentColor"
    />
    <circle
      cx="20"
      cy="13.7005"
      r="1.5"
      fill="currentColor"
      stroke="currentColor"
    />
    <circle
      cx="12"
      cy="9.70052"
      r="1.5"
      fill="currentColor"
      stroke="currentColor"
    />
    <circle
      cx="4"
      cy="18.7005"
      r="1.5"
      fill="currentColor"
      stroke="currentColor"
    />
    <circle
      cx="28"
      cy="5.70052"
      r="1.5"
      fill="currentColor"
      stroke="currentColor"
    />
  </svg>
)

export const IconGraph: React.FC<IconProps> = (props) => (
  <svg
    width="22"
    height="21"
    viewBox="0 0 22 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.625 16.175L-1.78814e-07 15L5 7L8 10.5L12 4L14.725 8.075C14.3417 8.09167 13.9792 8.1375 13.6375 8.2125C13.2958 8.2875 12.9583 8.39167 12.625 8.525L12.075 7.7L8.275 13.875L5.25 10.35L1.625 16.175ZM20.575 21L17.45 17.875C17.1167 18.1083 16.7458 18.2833 16.3375 18.4C15.9292 18.5167 15.5083 18.575 15.075 18.575C13.825 18.575 12.7625 18.1375 11.8875 17.2625C11.0125 16.3875 10.575 15.325 10.575 14.075C10.575 12.825 11.0125 11.7625 11.8875 10.8875C12.7625 10.0125 13.825 9.575 15.075 9.575C16.325 9.575 17.3875 10.0125 18.2625 10.8875C19.1375 11.7625 19.575 12.825 19.575 14.075C19.575 14.5083 19.5167 14.9292 19.4 15.3375C19.2833 15.7458 19.1083 16.125 18.875 16.475L22 19.575L20.575 21ZM15.075 16.575C15.775 16.575 16.3667 16.3333 16.85 15.85C17.3333 15.3667 17.575 14.775 17.575 14.075C17.575 13.375 17.3333 12.7833 16.85 12.3C16.3667 11.8167 15.775 11.575 15.075 11.575C14.375 11.575 13.7833 11.8167 13.3 12.3C12.8167 12.7833 12.575 13.375 12.575 14.075C12.575 14.775 12.8167 15.3667 13.3 15.85C13.7833 16.3333 14.375 16.575 15.075 16.575ZM17.3 8.575C16.9833 8.44167 16.6542 8.33333 16.3125 8.25C15.9708 8.16667 15.6167 8.11667 15.25 8.1L20.375 0L22 1.175L17.3 8.575Z"
      fill="currentColor"
    />
  </svg>
)

export const IconMix: React.FC<IconProps> = (props) => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.00002 4.85077C4.02219 4.85077 4.85083 4.02213 4.85083 2.99996C4.85083 1.97778 4.02219 1.14915 3.00002 1.14915C1.97784 1.14915 1.14921 1.97778 1.14921 2.99996C1.14921 4.02213 1.97784 4.85077 3.00002 4.85077Z"
      stroke="currentColor"
      strokeWidth="0.5"
    />
    <path
      d="M1.49998 8.16331V11.8369L4.82034 10.0001L1.49998 8.16331Z"
      stroke="currentColor"
      strokeWidth="0.5"
    />
    <rect
      x="7.80001"
      y="7.80003"
      width="4.4"
      height="4.4"
      stroke="currentColor"
      strokeWidth="0.5"
    />
    <line
      x1="7.5"
      y1="0.5"
      x2="12.5"
      y2="5.5"
      stroke="currentColor"
      strokeWidth="0.5"
    />
    <line
      x1="7.5"
      y1="5.5"
      x2="12.5"
      y2="0.5"
      stroke="currentColor"
      strokeWidth="0.5"
    />
  </svg>
)

// TODO: move this to editorial
export const ColumnIconMap = {
  brands: IconStates, // TODO: it looks like there is a mismatch between the brands and the filter brands
  safegraph_brands: IconStates,
  top_category: IconMetropolitans,
  region: IconVenues,
  us_state_2020: IconVenues,
  us_state: IconVenues,
  city: IconZips,
  us_county_2020: IconCounties,
  us_cbsa_2020: IconNeighbourhoods,
  no_ab_1_2024: IconStates,
  no_ab_2_2024: IconMetropolitans,
}
